export default {
  jp: {
    title: '仮パスワード変更',
    label: {
      password: 'パスワード',
      passwordConfirm: 'パスワード'
    },
    ph: {
      password: 'パスワードを入力してください',
      passwordConfirm: 'パスワード（確認用）を入力してください'
    },
    error: {
      accountId: {
        expiresTempPassword: '仮パスワードが期限切れになっています。',
        notTempAuth: '既に本パスワードでログイン済みです。'
      },
      password: {
        required: 'パスワードを入力してください',
        invalidPolicy: '入力したパスワードはパスワードポリシーの要件を満たしていません。',
        equalsTempPassword: '入力したパスワードは仮パスワードと同一です。新しいパスワードを入力してください。'
      },
      passwordConfirm: {
        required: 'パスワード（確認用）を入力してください',
        invalidPolicy: '入力したパスワード（確認用）はパスワードポリシーの要件を満たしていません。',
        notEqualsPassword: 'パスワードとパスワード（確認用）の入力内容が一致しておりません。'
      }
    },
    button: {
      change: 'パスワードを変更する'
    },
    desc: {
      text1: '新しいパスワードに以下を満たしている文字を2回入力してください。',
      text2: '・8文字以上であること',
      text3: '・半角の英大文字／英小文字／数字／記号のうち、2種類以上の文字種を組み合わせていること'
    }
  },
  en: {
    title: 'Change Temporary Password',
    label: {
      password: 'password',
      passwordConfirm: 'confirm Password'
    },
    ph: {
      password: 'Enter your password',
      passwordConfirm: 'Enter confirm Password'
    },
    error: {
      accountId: {
        expiresTempPassword: 'Your temporary password has expired.',
        notTempAuth: 'You are already logged in with the new password.'
      },
      password: {
        required: 'Please enter your password.',
        maxLength: 'Password must be 8-100 characters in length.',
        invalidPolicy: 'Password does not meet the requirements.',
        equalsTempPassword: 'The password is the same with the temporary password. Please enter your new password.'
      },
      passwordConfirm: {
        required: 'Please enter your confirm Password.',
        maxLength: 'The password must be between 8 and 100 characters long.',
        notEqualsPassword: 'Password and confirm password does not match'
      }
    },
    button: {
      change: 'Change Password'
    },
    desc: {
      text1: 'Enter the new password twice which meets the following.',
      text2: '- Must be 8 or more characters',
      text3: '- Must be a combination of two or more character types among capital letters, lowercase letters, numbers, and symbols.'
    }
  }

}
